import { ref, onMounted, onBeforeUnmount } from 'vue'
import type { Ref } from 'vue'

export function useScrollable(containerRef: Ref<HTMLElement | null>) {
  const isScrollable = ref(false)
  const scrolling = ref(false)
  let scrollTimeout: number | undefined

  const checkScrollable = () => {
    setTimeout(() => {
      if (containerRef.value) {
        isScrollable.value = containerRef.value.scrollHeight > containerRef.value.clientHeight
      }
    }, 100)
  }

  const onScroll = () => {
    scrolling.value = true
    if (scrollTimeout) clearTimeout(scrollTimeout)
    scrollTimeout = window.setTimeout(() => {
      scrolling.value = false
    }, 500)
  }

  onMounted(() => {
    if (containerRef.value) {
      containerRef.value.addEventListener('scroll', onScroll)
    }
    window.addEventListener('resize', checkScrollable)
    checkScrollable()
  })

  onBeforeUnmount(() => {
    if (containerRef.value) {
      containerRef.value.removeEventListener('scroll', onScroll)
    }
    window.removeEventListener('resize', checkScrollable)
  })

  return { isScrollable, checkScrollable, scrolling }
}
